<div class="service-settings-page">

  <button mat-flat-button color="default" [routerLink]="['/library']" class="back-to-library-btn">
    <mat-icon>arrow_back</mat-icon> Back to Library
  </button>

  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Advanced">
      <div *ngIf="error">
        <label style="color: red">{{error}}</label>
      </div>
      <br><br>
      <div class="example-section">
        <button mat-flat-button color="default" (click)="startSellerOnboarding()" [disabled]="isStartingOnboarding">
          <mat-icon>person_add</mat-icon>
          Become a seller
        </button>
      </div>
      <br>
      <!-- Quick access to Landing 2025 page -->
      <div class="example-section">
        <button mat-flat-button  color="default"  [routerLink]="['/landing2025']" matTooltip="Open landing 2025 page">
          <mat-icon>open_in_new</mat-icon>
          Open Landing 2025 (web)
        </button>
      </div>
      <br>
      <mat-checkbox [(ngModel)]="settingsService.ignoreRenderLimitCheck" ><strong>Ignore render limit check on frontend</strong></mat-checkbox>
      <br><br>
      <mat-checkbox [(ngModel)]="settingsService.showStyleTweaker" ><strong>Show style tweaker for store</strong></mat-checkbox>
      <section class="example-section">
        <label class="example-margin">Notif. Level:</label>
        <mat-radio-group [(ngModel)]="settingsService.logLevelSelector">
          <mat-radio-button class="example-margin" [value]="LOG_LEVEL_OPTION.DEFAULT">
            Default
          </mat-radio-button>
          <mat-radio-button class="example-margin" [value]="LOG_LEVEL_OPTION.ERROR_ONLY">
            ErrorsOnly
          </mat-radio-button>
          <mat-radio-button class="example-margin" [value]="LOG_LEVEL_OPTION.PROD_MODE">
            Prod
          </mat-radio-button>
        </mat-radio-group>
        <br><br>
        <br><br>
        <label class="example-margin">Frames to render </label>
        <input type="number" class="blacked-input" [placeholder]="900" [(ngModel)]="settingsService.frameNumberToRender" >
        <br>
        <br>
        <mat-checkbox [(ngModel)]="settingsService.showDateModified" ><strong>Show modified date on thumbs</strong></mat-checkbox>
        <br>
        <br>
        <mat-checkbox [(ngModel)]="settingsService.additionalSettingsEnabled" ><strong>Additional Settings Enabled</strong></mat-checkbox>
        <br>
        <br>
        <hr>
          <br>
          <label class="example-margin">DONT FORGET TO RELAUNCH APP AFTER CHANGING FEED SOURCE!</label>
          <br>
          <br>

          <section class="example-section">

            Your User UID (Original): <input type="string" style="width: 250px;" class="blacked-input-large" readonly value="{{originalUid}}" ><br>
            Your User UID (Current): {{customUid}} <br><br>
            <label class="example-margin">Set custom UID: </label>
            <input type="string" class="blacked-input-large" [placeholder]="" [(ngModel)]="newCustomUid" >
            <br><br>
            <button mat-flat-button color="default" (click)="applyUid()">Apply custom UID</button>
            <br><br>
          </section>
        <hr>
        <br>
        <br>
        <button mat-flat-button color="default" (click)="clearUploads()">Clear upload models</button>
        <br>
        <br>
        <hr>
        <br>
        <label class="example-margin">Add textures to model: </label>
        <input type="string" class="blacked-input-large" placeholder="Enter Model ID" [(ngModel)]="modelIdForTextures" >
        <br><br>
        <label class="example-margin">Textures Root Path: </label>
        <input type="string" class="blacked-input-large" placeholder="Enter Textures Root Path" [(ngModel)]="texturesRootPath" >
        <br><br>
        <button mat-flat-button color="default" (click)="addTexturesToModel()">Add Textures to Model</button>
        <br>
        <br>
        <hr>
        <br>
        <button mat-flat-button color="default" (click)="restorePurchases()">restorePurchases</button>
        <br>
        <br>
        <button mat-flat-button color="default" (click)="manageSubscriptions()">manageSubscriptions</button>
        <br>
        <br>
        <button mat-flat-button color="default" (click)="manageBilling()">manageBilling</button>
        <br>
        <br>
        <h5> <strong> Log for finishing products: </strong>  </h5>
        <pre *ngFor="let product of approvedProdcuts">
           {{product | json}}
        </pre>
        <br>

        <!-- <label class="example-margin">Progress bar hide delay: </label>
        <input type="number" class="blacked-input" [placeholder]="1000" [(ngModel)]="settingsService.progressBarHideDelay" >
        <br> -->
        <!-- <section class="example-section">
          <label class="example-margin">Delay lable type:</label>
          <mat-radio-group [(ngModel)]="settingsService.delayProgressType">
            <mat-radio-button class="example-margin" value="progressBar">
              Circle
            </mat-radio-button>
            <mat-radio-button class="example-margin" value="autoplayLabel">
              AutoPlay
            </mat-radio-button>
            <mat-radio-button class="example-margin" value="spinner">
              Spinner
            </mat-radio-button>
            <mat-radio-button class="example-margin" value="none">
              None
            </mat-radio-group>
        </section> -->



        <button mat-flat-button color="default" (click)="getToken()">Get Auth Token</button>
        <br>
        <br>
        <label class="example-margin">DOM-Skeleton Chunk Length: </label>
        <input type="number" class="blacked-input" [placeholder]="2" [(ngModel)]="settingsService.skeletonChunkLength" >
        <br>
        <br>
        <label class="example-margin">Card render buffer(Should be even number): </label>
        <input type="number" class="blacked-input" [placeholder]="4" [(ngModel)]="settingsService.cardRenderBuffer" >

      </section>
      <div class="checkbox-wrapper ">
      </div>

      <br>
      <button mat-flat-button color="error" (click)="openDeleteCardConfirmationDialog()">delete all models</button>
      <br>

      <br>
      <pre>
        <!-- {{ settingsService.processCardStats(cardService.cardProgressStats) | json}} -->
      </pre>
      <br>
    </mat-tab>
    <mat-tab label="Visuals">

      <div class="checkbox-wrapper margin-top-10">
        <label class="example-margin">Video resize type:</label>
        <mat-radio-group [(ngModel)]="settingsService.videoResizeType">
          <mat-radio-button class="example-margin" value="cover">
            Cover
          </mat-radio-button>
          <mat-radio-button class="example-margin" value="fill">
            Fill
          </mat-radio-button>
          <mat-radio-button class="example-margin" value="contain">
            Contain
          </mat-radio-button>
        </mat-radio-group>
    </div>

      <br>
      <label class="example-margin">Snackbar appear timing: </label>
      <input type="number" class="blacked-input" [placeholder]="350" [(ngModel)]="settingsService.snackBarAppearTiming" >
      <br>
      <br>
      <label class="example-margin">Snackbar hide timing: </label>
      <input type="number" class="blacked-input" [placeholder]="200" [(ngModel)]="settingsService.snackBarHideTiming" >
      <br>
      <br>
      <label class="example-margin">Snackbar appear start scale: </label>
      <input type="number" class="blacked-input" [placeholder]="0.6" [(ngModel)]="settingsService.snackBarAppearScale" >
      <br>
      <br>
      <button mat-flat-button color="default" (click)="patchSnackBarAnimation()">Apply snack animation changes</button>
      <br>
      <br>

      <br>
      <label class="example-margin">Grad 'fadein' time: </label>
      <input type="number" class="blacked-input" [placeholder]="400" [(ngModel)]="settingsService.wrapperAnimationTime" >
      <label class="example-margin margin-left">Grad 'fadein' delay: </label>
      <input type="number" class="blacked-input"  [placeholder]="250" [(ngModel)]="settingsService.wrapperAnimationDelay" >
      <br>
      <label class="example-margin">Title 'fadein' time: </label>
      <input type="number" class="blacked-input" [placeholder]="450" [(ngModel)]="settingsService.titleAnimationTime" >
      <label class="example-margin margin-left">Title 'fadein' delay: </label>
      <input type="number" class="blacked-input" [placeholder]="300" [(ngModel)]="settingsService.titleAnimationDelay" >
      <br>
      <label class="example-margin">Desc 'fadein' time: </label>
      <input type="number" class="blacked-input" [placeholder]="300" [(ngModel)]="settingsService.descriptionAnimationTime" >
      <label class="example-margin margin-left">Desc 'fadein' delay: </label>
      <input type="number" class="blacked-input" [placeholder]="950" [(ngModel)]="settingsService.descriptionAnimationDelay" >
      <br>
      <br>


      <br>
      <label class="example-margin">Collection details scroll speed: </label>
      <input type="number" class="blacked-input" [placeholder]="500" [(ngModel)]="settingsService.collectionDetailsScrollSpeed" >
      <br>
      <br>
      <label class="example-margin">Discover btn event trigger delay: </label>
      <input type="number" class="blacked-input" [placeholder]="50" [(ngModel)]="settingsService.discoverBtnEventDelayTime" >
      <br>
      <br>
      <label class="example-margin">Back btn event trigger delay: </label>
      <input type="number" class="blacked-input" [placeholder]="50" [(ngModel)]="settingsService.backBtnEventDelayTime" >
      <br>
      <br>
      <label class="example-margin">Home btn event trigger delay: </label>
      <input type="number" class="blacked-input" [placeholder]="50" [(ngModel)]="settingsService.homeBtnEventDelayTime" >
      <br>
      <br>
      <label class="example-margin">Card start delay: </label>
      <input type="number" class="blacked-input" [placeholder]="2000" [(ngModel)]="settingsService.cardStartDelayTime" >
      <br>


    </mat-tab>
    <mat-tab label="AI Settings">
      <div class="ai-settings-section">
        <!-- <div class="ratings-management" style="margin-bottom: 20px;">
          <h3>Ratings Management</h3>
          <button mat-flat-button color="warn" (click)="deleteAllRatings()" [disabled]="isDeletingRatings || getUserRatingsCount() === 0">
            <mat-icon>delete_forever</mat-icon>
            {{ isDeletingRatings ? 'Deleting...' : getDeleteButtonText() }}
          </button>
          <p class="hint">{{ getUserRatingsCount() === 0 ? 'No ratings to delete.' : 'This will remove all your ratings from the analysis table.' }}</p>
        </div> -->

        <h4>AI Provider Selection</h4>
        <br>
        <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
          <div class="card h-100">
            <div class="card-body">
              <div class="form-group">
                <label for="aiProvider">Select AI Provider</label>
                <select class="form-control" id="aiProvider" [(ngModel)]="selectedProvider" (change)="onProviderChange()">
                  <option value="openai">🤖 OpenAI</option>
                  <option value="gemini">🔮 Google Gemini</option>
                </select>
                <div class="form-group" *ngIf="selectedProvider === 'openai'" style="margin-top: 16px;">
                  <label for="openaiModel">OpenAI Model</label>
                  <select class="form-control" id="openaiModel" [(ngModel)]="selectedOpenAIModel" (change)="onOpenAIModelChange()">
                    <option *ngFor="let model of openAIModels" [value]="model.value">{{ model.label }}</option>
                  </select>
                  <small class="form-text text-muted">Ensure your API key has access to the selected model.</small>
                </div>
                <div class="form-group" *ngIf="selectedProvider === 'gemini'" style="margin-top: 16px;">
                  <label for="geminiModel">Gemini Model</label>
                  <select class="form-control" id="geminiModel" [(ngModel)]="selectedGeminiModel" (change)="onGeminiModelChange()">
                    <option *ngFor="let model of geminiModels" [value]="model.value">{{ model.label }}</option>
                  </select>
                </div>
                <br>
                <p>Currently using: <strong>{{ providerDisplayName }}</strong> for all AI analysis</p>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <br>
        <h4>Video Frame Extraction Settings</h4>
        <br>
        <label class="example-margin">Number of frames to extract from video (1-4):</label>
        <br>
        <mat-radio-group [(ngModel)]="aiFramesCount" (ngModelChange)="onFramesCountChange($event)">
          <mat-radio-button class="example-margin" [value]="1">
            1 frame (image mode) - Default
          </mat-radio-button>
          <br><br>
          <mat-radio-button class="example-margin" [value]="2">
            2 frames (first + middle)
          </mat-radio-button>
          <br><br>
          <mat-radio-button class="example-margin" [value]="3">
            3 frames (first + 1/3 + 2/3)
          </mat-radio-button>
          <br><br>
          <mat-radio-button class="example-margin" [value]="4">
            4 frames (0% + 25% + 50% + 75%)
          </mat-radio-button>
        </mat-radio-group>
        <hr>
        <br>
        <h4>AI Temperature Settings</h4>
        <br>
        <label class="example-margin">Temperature (creativity level): {{ aiTemperature }}</label>
        <br>
        <mat-slider
          min="0.1"
          max="1.0"
          step="0.1"
          class="temperature-slider">
          <input matSliderThumb [(ngModel)]="aiTemperature" (ngModelChange)="onTemperatureChange($event)">
        </mat-slider>
        <div class="temperature-labels">
          <span class="temp-label-low">0.1 - More focused</span>
          <span class="temp-label-high">1.0 - More creative</span>
        </div>
        <br>
        <button mat-flat-button color="default" (click)="resetTemperatureToDefault()" class="margin-left">
          Reset Temperature (0.4)
        </button>
        <br>

        <!-- OpenAI Thinking Budget Slider (only visible for OpenAI provider) -->
        <div *ngIf="selectedProvider === 'openai'" class="thinking-budget-section">
          <br>
          <label class="example-margin">OpenAI Thinking Budget (tokens): {{ aiThinkingBudget }}</label>
          <br>
          <mat-slider
            min="1000"
            max="10000"
            step="500"
            class="thinking-budget-slider">
            <input matSliderThumb [(ngModel)]="aiThinkingBudget" (ngModelChange)="onThinkingBudgetChange($event)">
          </mat-slider>
          <div class="thinking-budget-labels">
            <span class="budget-label-low">1000 - Quick</span>
            <span class="budget-label-high">10000 - Deep analysis</span>
          </div>
          <br>
          <button mat-flat-button color="default" (click)="resetThinkingBudgetToDefault()" class="margin-left">
            Reset Thinking Budget (4000)
          </button>
          <p class="hint-text" style="font-size: 12px; color: #666; margin-top: 8px;">
            Higher thinking budget allows OpenAI models to spend more computational effort on problem-solving.
            Used for o1, o3, and o3-mini models.
          </p>
        </div>

        <br>
        <br>
        <hr>
        <br>
        <!-- Prompt Configuration Section -->
        <div class="prompt-config-section">
          <div class="prompt-editor" *ngFor="let promptType of promptTypes; let i = index">
            <h4>{{ getColumnVariationName(i) }} Prompt</h4>
            <textarea
              [(ngModel)]="promptType.prompt"
              class="ai-prompt-textarea"
              rows="8"
              cols="80"
              placeholder="Enter prompt for {{ getColumnVariationName(i) }}...">
            </textarea>
            <div class="prompt-actions">
              <button mat-flat-button color="accent" (click)="resetPromptToDefault(promptType.key, 'system')" [disabled]="promptType.prompt === promptType.systemPrompt">
                Reset to System Default
              </button>
              <button mat-flat-button color="accent" (click)="resetPromptToDefault(promptType.key, 'json')" [disabled]="!promptType.jsonPromptAvailable || promptType.prompt === promptType.jsonPrompt" class="margin-left">
                Reset to JSON Default
              </button>
            </div>
          </div>
        </div>

        <div class="table-actions">
          <button mat-flat-button color="default" (click)="analyzeAllImages()" [disabled]="isAnalyzing">
            {{ isAnalyzing ? 'Analyzing...' : 'Analyze ALL Images' }}
          </button>
          <button mat-flat-button color="warn" (click)="cancelAnalysis()" [disabled]="!isAnalyzing" class="margin-left">
            Stop Analysis
          </button>
          <button mat-flat-button color="default" (click)="analyzeAllWiki()" [disabled]="isAnalyzingWiki" class="margin-left">
            {{ isAnalyzingWiki ? 'Analyzing Wiki...' : 'Analyze Wiki' }}
          </button>
          <button mat-flat-button color="warn" (click)="cancelWikiAnalysis()" [disabled]="!isAnalyzingWiki" class="margin-left">
            Stop Analyze Wiki
          </button>
          <button mat-flat-button color="default" (click)="analyzeAllClarity()" [disabled]="isAnalyzingClarity" class="margin-left">
            {{ isAnalyzingClarity ? 'Analyzing Clarity...' : 'Analyze Clarity ALL Models' }}
          </button>
          <button mat-flat-button color="warn" (click)="cancelClarityAnalysis()" [disabled]="!isAnalyzingClarity" class="margin-left">
            Stop Clarity Analysis
          </button>
          <button mat-flat-button color="default" (click)="clearAllResults()" class="margin-left">
            Clear All Results
          </button>
          <button mat-flat-button color="default" (click)="clearAllClarityResults()" class="margin-left">
            Clear Clarity Results
          </button>

          <button mat-flat-button color="accent" (click)="exportResultsToJson()" class="long-btn margin-left">
            Export Results / Prompt Settings (JSON)
          </button>

          <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)" accept=".json">
          <button mat-flat-button color="accent" (click)="triggerFileUpload()" class="margin-left">
            Load Data from File
          </button>
        </div>
        <br>

        <div class="analysis-table-container">
          <table class="analysis-table">
            <thead>
              <tr>
                <th class="image-column">Image</th>
                <th *ngFor="let promptType of tablePromptTypes; let i = index" class="prompt-column">
                  <div class="prompt-header">
                    <span class="prompt-name">{{ getColumnVariationName(i) }}</span>
                  </div>
                </th>
                <th class="boundary-column">Boundary Conditions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let image of testImages; let imageIndex = index" class="image-row">
                <td class="image-cell">
                  <div class="image-info">
                    <img [src]="image.posterUrl" [alt]="image.name" class="thumbnail-image"
                         (click)="openImageDialog(image)"
                         title="Click to view full size image" />
                    <div class="image-name-wrapper">
                      <span class="image-name">{{ image.name }}</span>
                      <a *ngIf="image.preview_link_web" [href]="image.preview_link_web" target="_blank" class="preview-link" matTooltip="Open preview link">
                        <mat-icon>link</mat-icon>
                      </a>
                    </div>
                  </div>
                </td>
                <td *ngFor="let promptType of tablePromptTypes; let promptIndex = index" class="result-cell">
                  <div class="cell-content">
                    <!-- Short description content -->
                    <div class="result-content" *ngIf="hasResult(imageIndex, promptType.key)">
                      <div class="short-description">
                        <h1>{{ getModelName(imageIndex, promptType.key) }}</h1>
                        {{ getShortDescription(imageIndex, promptType.key) }}
                      </div>

                      <!-- Full analysis expansion -->
                      <div *ngIf="showFullAnalysis[imageIndex][promptType.key]" class="full-analysis">
                        <div class="full-analysis-content">
                          {{ getFullDescription(imageIndex, promptType.key) }}
                        </div>
                      </div>
                    </div>

                    <div class="loading-message"
                         *ngIf="isLoading(imageIndex, promptType.key)">
                      Analyzing with {{ getProviderFriendlyName() }}...
                      <mat-progress-spinner
                        diameter="16"
                        mode="indeterminate">
                      </mat-progress-spinner>
                    </div>

                    <!-- Control buttons in bottom right -->
                    <div class="cell-controls">
                      <div
                        *ngIf="hasResult(imageIndex, promptType.key)"
                        class="char-count-indicator"
                        [ngClass]="getCharCountColorClass(imageIndex, promptType.key)"
                        title="Short description character count">
                        {{ getShortDescriptionCharCount(imageIndex, promptType.key) }}
                      </div>

                      <button
                        mat-stroked-button
                        color="accent"
                        (click)="analyzeImage(imageIndex, promptType.key)"
                        [disabled]="isLoading(imageIndex, promptType.key)"
                        class="analyze-btn-small"
                        [title]="hasResult(imageIndex, promptType.key) ? 'Re-analyze with ' + getProviderFriendlyName() : 'Analyze with ' + getProviderFriendlyName()">
                        <mat-icon>{{ hasResult(imageIndex, promptType.key) ? 'refresh' : 'auto_fix_high' }}</mat-icon>
                      </button>


                      <button
                        *ngIf="hasResult(imageIndex, promptType.key)"
                        mat-stroked-button
                        color="primary"
                        (click)="toggleFullAnalysis(imageIndex, promptType.key)"
                        class="info-btn-small"
                        [title]="showFullAnalysis[imageIndex][promptType.key] ? 'Hide full analysis' : 'Show full analysis'">
                        <mat-icon>{{ showFullAnalysis[imageIndex][promptType.key] ? 'expand_less' : 'info' }}</mat-icon>
                      </button>
                    </div>

                    <!-- Rating section for this prompt -->
                    <!-- <div class="rating-section" *ngIf="hasResult(imageIndex, promptType.key)">

                      <div *ngIf="getAverageRating(imageIndex, promptType.id) > 0" class="average-rating-section">
                        <div class="average-rating-label">Avg: {{ formatRating(getAverageRating(imageIndex, promptType.id)) }}/10</div>
                        <mat-progress-bar
                          mode="determinate"
                          [value]="getAverageRating(imageIndex, promptType.id) * 10"
                          [class]="getRatingColorClass(getAverageRating(imageIndex, promptType.id))"
                          class="average-rating-bar">
                        </mat-progress-bar>
                        <div class="rating-count" *ngIf="getRatingCount(imageIndex, promptType.id) > 0">
                          ({{ getRatingCount(imageIndex, promptType.id) }} ratings)
                        </div>
                      </div>

                      <div class="rating-input">

                        <div *ngIf="getUserRating(imageIndex, promptType.id) !== null && getUserRating(imageIndex, promptType.id) !== undefined" class="rating-slider-section">

                          <mat-slider min="1" max="10" step="1" class="rating-slider">
                            <input matSliderThumb
                                  [value]="getUserRating(imageIndex, promptType.id)"
                                  (input)="onRatingChange($event, imageIndex, promptType.id)">
                          </mat-slider>
                          <div class="rating-value-display">
                            <span class="current-rating">{{ getUserRating(imageIndex, promptType.id) }}</span>
                            <span class="rating-max">/ 10</span>
                          </div>
                        </div>

                        <div *ngIf="getUserRating(imageIndex, promptType.id) === null || getUserRating(imageIndex, promptType.id) === undefined"
                             class="rating-placeholder">
                          <button mat-stroked-button
                                  color="primary"
                                  (click)="startRating(imageIndex, promptType.id)"
                                  class="start-rating-btn">
                            <mat-icon>star</mat-icon>
                            Rate description
                          </button>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </td>

                <!-- Description Accuracy Column -->
                <td class="boundary-cell">
                  <div class="boundary-content">
                    <button mat-icon-button
                            class="analyze-boundary-btn"
                            color="primary"
                            (click)="analyzeBoundaryConditions(imageIndex)"
                            [disabled]="isBoundaryAnalyzing(imageIndex)"
                            [title]="hasBoundaryResult(imageIndex) ? 'Re-analyze clarity' : 'Analyze clarity'">
                      <mat-icon>{{ hasBoundaryResult(imageIndex) ? 'refresh' : 'psychology' }}</mat-icon>
                    </button>

                    <div *ngIf="isBoundaryAnalyzing(imageIndex)" class="boundary-loading">
                      <span>Analyzing clarity...</span>
                      <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
                    </div>

                    <div *ngIf="hasBoundaryResult(imageIndex)" class="boundary-result">
                      <div class="boundary-score">
                        <span class="score-label">Clarity Score</span>
                        <span class="score-value">{{ getBoundaryScore(imageIndex) }}%</span>
                        <span class="ambiguity-level">{{ getAmbiguityLevel(imageIndex) }}</span>
                      </div>
                      <mat-progress-bar
                        mode="determinate"
                        [value]="getBoundaryScore(imageIndex)"
                        [ngClass]="getBoundaryScoreColorClass(imageIndex)"
                        class="boundary-progress">
                      </mat-progress-bar>
                      <div class="boundary-reasoning" *ngIf="getBoundaryReasoning(imageIndex)">
                        {{ getBoundaryReasoning(imageIndex) }}
                      </div>
                    </div>

                    <!-- Model Comment Section -->
                    <!-- Show "Add comment" button when no comment exists and form is not shown -->
                    <div *ngIf="!hasComment(imageIndex) && !showCommentForm[imageIndex]" class="add-comment-section">
                      <button mat-stroked-button
                              color="primary"
                              (click)="showCommentInput(imageIndex)"
                              class="add-comment-btn">
                        <mat-icon>add_comment</mat-icon>
                        Add comment
                      </button>
                    </div>

                    <!-- Show full comment form when comment exists or form is being shown -->
                    <div *ngIf="hasComment(imageIndex) || showCommentForm[imageIndex]" class="model-comment-section">
                      <div class="comment-header">
                        <label class="comment-label">Model Notes:</label>
                        <div class="comment-actions">
                          <button mat-icon-button
                                  color="primary"
                                  (click)="saveComment(imageIndex)"
                                  [disabled]="isSavingComment[imageIndex]"
                                  matTooltip="Save comment"
                                  class="save-comment-btn">
                            <mat-icon>{{ isSavingComment[imageIndex] ? 'hourglass_empty' : 'save' }}</mat-icon>
                          </button>
                        </div>
                      </div>

                      <textarea
                        [(ngModel)]="modelComments[imageIndex]"
                        (input)="onCommentChange(imageIndex)"
                        class="comment-textarea"
                        placeholder="Add notes about this model..."
                        rows="3"
                        maxlength="500">
                      </textarea>

                      <div class="comment-info" *ngIf="getLastUpdatedByDisplay(imageIndex)">
                        <small class="last-updated-info">{{ getLastUpdatedByDisplay(imageIndex) }}</small>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Image Dialog Template -->
<ng-template #imageDialogTemplate>
  <div class="image-dialog" >
    <div class="image-dialog-header">
      <h2 mat-dialog-title>{{ selectedImage?.name }}</h2>
      <button mat-icon-button mat-dialog-close aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div mat-dialog-content class="image-dialog-content">
      <img [src]="selectedImage?.posterUrl" style="width: 100%" [alt]="selectedImage?.name" class="full-size-image" />
    </div>

    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </div>
  </div>
</ng-template>
